import { Grid, IconButton, keyframes, Typography } from "@mui/material";
import { ReactNode, useRef } from "react";
import { DraggableButton } from "react-draggable-button";
import { awaitTime } from "../../utils";
import { FaWhatsapp } from "react-icons/fa"

export function Support({ children }: { children: ReactNode }) {
    const containerRef = useRef<HTMLDivElement>(null)

    const pulseAnimation = keyframes`
        0% {
        transform: scale(1);
        }
        50% {
        transform: scale(1.2);
        }
        100% {
        transform: scale(1);
        }
    `

    return (
        <Grid ref={containerRef} height={"calc(100vh- 50)"} width={"calc(100vw - 50)"} position="relative" sx={{
            backgroundColor: 'transparent !important',
            margin: '10px -8px',
            overflowX: 'hidden !important',
            overflowY: 'hidden !important'
        }}>
            <DraggableButton
                containerRef={containerRef}
                device='auto'
                backgroundColor='transparent'
                height={50}
                width={50}
                borderRadius={25}
                initialBottom={50}
                initialRight={50}
                borderMargin={40}
                animationTimig={2}
                resizeTaxOnMove={0.1}
                zIndex={100}
                children={<Grid position="absolute">
                    <Grid sx={{ position: 'relative', display: 'flex', alignContent: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                        <Typography textAlign={"center"} color={"red"}>Suporte <br />Atendimento</Typography>
                        <IconButton sx={{
                            maxWidth: 260,
                            width: '100%',
                            p: 2,
                            animation: `${pulseAnimation} 2s ease infinite`
                        }}>
                            <FaWhatsapp size={50} color="#25D366" />
                        </IconButton>
                    </Grid>
                </Grid >}
                onClick={(async () => {
                    //esse timing não faz sentido, mas se tirar vai executar essa função 2 vezes. Pq? só Deus sabe
                    await awaitTime(0.5)
                    window.open("https://wa.me/+5512992095567", "_blank")
                })}
                pressTimeToClick={0.1}
            />
            {children}
        </Grid>
    )

}